import Link from 'next/link';
import React, { CSSProperties } from 'react';
import Button from '../buttons/Button';
import { Box } from '../layout';
import { Text, SmallHeading } from '../typography';

export interface CanBook {
  available: boolean;
  availableTimePeriod?: string | null | undefined;
  title: string;
  subtitle?: string | React.ReactNode;
}

export interface BookButton {
  text: string;
  href: string;
}

interface PremierBookButtonProps {
  canBook: CanBook;
  button: BookButton;
  testID?: string;
  containerStyle?: CSSProperties;
}

const PremierBookButton: React.FC<PremierBookButtonProps> = ({ canBook, button, testID, containerStyle }) => {
  if (canBook.available)
    return (
      <Link
        href={button.href}
        prefetch={false}
        className="link-button"
        target="_blank"
        rel="noreferrer"
        data-testid={testID || 'feature-btn'}
      >
        <Button containerStyle={containerStyle}>{button.text}</Button>
      </Link>
    );

  return (
    <Box w="100%" maxWidth={700} data-testid="premier-booking-unavailable" mt={10}>
      <SmallHeading align="center" fontSize={24} fontWeight="bold">
        {canBook.title}
      </SmallHeading>
      {canBook.subtitle && (
        <Text align="center" mt={5} fontSize={18}>
          {canBook.subtitle}
          {canBook.availableTimePeriod && (
            <>
              {' '}
              <b>{canBook.availableTimePeriod}.</b>
            </>
          )}
        </Text>
      )}
    </Box>
  );
};

export default PremierBookButton;
